import React from 'react';
import {compose, withState} from 'recompose';
import Paragraph from '../Paragraph';
import './styles.scss';

const Disclaimer = ({ label, openAgreement, setOpenAgreement, openPrivacy, setOpenPrivacy }) => {
  return (
    <React.Fragment>
      <Paragraph className="disclaimer">
        Нажимая кнопку «{label}», вы принимаете<br />
        <a rel="noopener noreferrer" target="_blank" className="link-button" href="https://vcv.ru/assets/docs/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5_%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5.pdf">пользовательское соглашение</a>,&nbsp;
        <a rel="noopener noreferrer" target="_blank" className="link-button" href="https://vcv.ru/assets/docs/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0_%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D0%B8_%D0%9F%D0%94.pdf">правила хранения персональных данных</a><br />и даёте&nbsp;
        <a rel="noopener noreferrer" target="_blank" className="link-button" href="https://vcv.ru/assets/docs/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5_%D0%B4%D0%BB%D1%8F_%D1%81%D0%BE%D0%B8%D1%81%D0%BA%D0%B0%D1%82%D0%B5%D0%BB%D1%8F.pdf">согласие на сбор, обработку и хранение персональных данных</a>.
      </Paragraph>
    </React.Fragment>
  );
};

const enhance = compose(
  withState('openAgreement',  'setOpenAgreement', false),
  withState('openPrivacy', 'setOpenPrivacy', false),
);

export default enhance(Disclaimer);
